import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const CustomSelectionHeadCenter = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  margin-left: auto;
`;

const RevertButton = styled(Button)`
  gap: 8px;
`;

const SelectAllArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 4px;
  justify-content: center;
  padding: 8px;
`;

const SelectAllContactButton = styled(Button)`
  font-size: 12px;
  font-weight: 400;
`;

const SelectedContactText = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

const CreateLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
`;

const Email = styled.div`
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 200px;

  :hover {
    overflow-x: auto;
    text-overflow: inherit;
  }
`;

export {
  CreateLabelWrapper,
  CustomSelectionHeadCenter,
  Email,
  RevertButton,
  SelectAllArea,
  SelectAllContactButton,
  SelectedContactText
};
